import {Component, inject, Input} from '@angular/core';
import {MatIcon} from '@angular/material/icon';
import {Location} from '@angular/common';
import {Router} from '@angular/router';

@Component({
  selector: 'app-top-bar',
  imports: [
    MatIcon
  ],
  templateUrl: './top-bar.component.html',
  styleUrl: './top-bar.component.scss'
})
export class TopBarComponent {
  @Input() title = '';
  @Input() customLocation = '';
  @Input() isBack = false;
  public location: Location = inject(Location);
  public router: Router = inject(Router);

  public openLocation() {
    if(this.customLocation) {
      this.router.navigate([this.customLocation]);
    } else {
      this.location.back();
    }
  }
}
